<template>
  <div class="template">
    <DessinDesktop class="template__Desktop" />
    <DessinMobile class="template__Mobile" />
  </div>
</template>

<script>
import DessinMobile from '@/components/services/Mise-en-plan/DessinMobile.vue'
import DessinDesktop from '@/components/services/Mise-en-plan/DessinDesktop.vue'
export default {
  name: 'DessinView',
  components: {
    DessinDesktop,
    DessinMobile
  }
}
</script>


<style lang="scss">


.template__Desktop {
  display: none;
}

.template__Mobile {
  display: block;
}

@media screen and (min-width: 1024px) {
  .template__Desktop {
    display: block;
  }

  .template__Mobile {
    display: none;
  }
}
</style>